module.exports = __webpack_public_path__ + "img/currency-usd.5d9a3153.svg";